let htmlStr = `<div class="provacy-dialog" style="width: 100%;
height: 100%;
position: fixed;
top: 0;
left: 0;
z-index: 999;">
    <div style="background: #333;
    width: 100%;
    height: 100%;opacity:.9">
    </div>
    <div class="th-privacy-policy" style="width: 60%;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    padding: 20px;
    ">
        <h1 style="text-align: center;margin-bottom: 20px;font-size: 30px;">Before You Start</h1>
        <p style="line-height: 1.2;color:#222;margin-bottom: 10px;">Notice: According to Personal Data Protection Act 2019 (2562 B.E. (2019)) (hereafter referred as “PDPA”). We are required to get your consensus before we proceed to obtain your personal data. By reading and accepting this Privacy Policy, you are deemed to give such consent.  </p>
        <p style="line-height: 1.2;color:#222;margin-bottom: 10px;">As we promise:</p>
        <p style="line-height: 1.2;color:#222;margin-bottom: 10px;">(1) We will endeavor to ensure in each time it will not exceed what is reasonable to provide our product or service to you.  </p>
        <p style="line-height: 1.2;color:#222;margin-bottom: 10px;">(2) We will endeavor to ensure that your data will remain accurate, up-to-date，complete and not misleading.</p>
        <p style="line-height: 1.2;color:#222;margin-bottom: 10px;">(3) We will be processing your data strictly in accordance with its designated purpose.</p>
        <p style="line-height: 1.2;color:#222;margin-bottom: 10px;">You can now choose to——</p>
        <div style="display: flex;align-items: flex-start;">
            <input class="js-handle" type="checkbox" data-type="1"/>
            <p style="font-weight: bold;line-height: 1.2;color:#222;margin-bottom: 10px;">I accept and will proceed to read this policy in depth.</p>
        </div>
        <div style="display: flex;align-items: flex-start;">
            <input  class="js-handle" type="checkbox" data-type="2"/>
            <p style="font-weight: bold;line-height: 1.2;color:#222;margin-bottom: 10px;">I disagree and voluntarily withdraw my consent.</p>
        </div>
        <p style="line-height: 1.2;color:#222;margin-bottom: 10px;">You have the right to withdraw your consent in any events as prescribed by the PDPA. Please note that by withdrawing, you may not be able to enjoy the full extent of our services, functions, and protections. Click this <a style="text-decoration:underline;font-weight:bold" href="https://www.urbanrevivo.co.thpages/contact-us">button</a> to withdraw your consent.</p>
        <p style="line-height: 1.2;color:#222;margin-bottom: 10px;">We encourage you to read our full Privacy Policy below to understand fully how we will use your personal data and your rights over your data..</p>
    </div>
</div>`
console.log(123);
let isPage = location.href.indexOf('privacy-policy') > -1
let isAgree = localStorage.getItem('agree-privacy-policy')
if (isPage && !isAgree) {
    $('body').append(htmlStr)
    $('html').css('overflow','hidden')
}

$('body').on('click', '.js-handle', function () {
    $('.provacy-dialog').remove()
    let type = $(this).attr('data-type');
    if (type == 1) {
        localStorage.setItem('agree-privacy-policy', +new Date())
        $('html').css('overflow','scroll')
    } else {
        let masgStr = `<div id="privacy-mask" style="width: 100%;height: 100%;position: fixed;top: 0;left: 0;
        z-index: 9999999;
        background: #fff;
        opacity: .9;"><div/>`
        $('body').append(masgStr)
    }
})
$('body').on('click', '.box1,.box2,.box3,.box6,.box5', function () {
    let name = '#' + $(this).attr('class').trim()
    $(document).scrollTop($(name).offset().top - 95)
})
